import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';

const CaseTableLoading = ({ rowsPerPage, columnCount }) => {
  const skeletonRows = Number.parseInt(rowsPerPage, 10) || 10;
  const skeletonColumns = Number.parseInt(columnCount, 10) || 12;

  return (
    <Card className="crm-table-loading-card">
      <CardBody className="crm-table-loading">
        <div className="crm-table-loading__scroll">
          <div className="crm-table-loading__table">
            <div className="crm-table-loading__header">
              {Array.from({ length: skeletonColumns }).map((_, index) => (
                <div
                  key={`header-${index}`}
                  className={`crm-table-loading__cell ${index === 0 ? 'crm-table-loading__cell--checkbox' : ''}`}
                >
                  <div className={`crm-table-loading__bar ${index === 0 ? 'crm-table-loading__bar--checkbox' : 'crm-table-loading__bar--header'}`} />
                </div>
              ))}
            </div>
            <div className="crm-table-loading__body">
              {Array.from({ length: skeletonRows }).map((_, rowIndex) => (
                <div key={`row-${rowIndex}`} className="crm-table-loading__row">
                  {Array.from({ length: skeletonColumns }).map((__, columnIndex) => (
                    <div
                      key={`row-${rowIndex}-column-${columnIndex}`}
                      className={`crm-table-loading__cell ${columnIndex === 0 ? 'crm-table-loading__cell--checkbox' : ''}`}
                    >
                      <div className={`crm-table-loading__bar ${columnIndex === 0 ? 'crm-table-loading__bar--checkbox' : ''}`} />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="crm-table-loading__pagination">
          <div className="crm-table-loading__pagination-group">
            <div className="crm-table-loading__bar crm-table-loading__bar--pagination-label" />
            <div className="crm-table-loading__bar crm-table-loading__bar--pagination-select" />
          </div>
          <div className="crm-table-loading__pagination-group">
            <div className="crm-table-loading__bar crm-table-loading__bar--pagination-range" />
            <div className="crm-table-loading__pagination-actions">
              <div className="crm-table-loading__bar crm-table-loading__bar--pagination-action" />
              <div className="crm-table-loading__bar crm-table-loading__bar--pagination-action" />
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

CaseTableLoading.propTypes = {
  rowsPerPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  columnCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default CaseTableLoading;
